import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles'

export const Button = styled.a`
  border: none;
  color: #fff;
  font-weight: 500;
  font-size: 1.1rem;
  border-radius: 3rem;
  padding: 0.8rem 2.4rem;
  background-color: #000;
  float: right;
  min-width: px;
  margin: 0.5rem 0;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  &:hover {
    transform: translateX(0.6rem);
  }
`
export const Content = styled.div`
   min-height: 16rem;
}
`

export const DescriptionItem = styled.div`
  padding: 0.5rem 1rem;
  width: 100%;
  height: 10rem;
  border-radius: '5px';
  background-color: #f9f9f9;
`

export const Title = styled.h1`
  font-size: 1.5vw;
  line-height: 1.2;
  font-weight: 900;
  text-transform: uppercase;
  color: #002550;
  padding-top: 10px;
  margin-bottom: 1rem;
  @media only screen and (max-width: 600px) {
    font-size: 5vw;
  }
`

export const ImgWrapper = styled.div`
  display: block;
  height: 100%;
  overflow: hidden;
  padding: 56.25% 0 0 0;
  position: relative;
  width: 100%;
`

export const Img = styled.img`
  box-shadow: 0 10px 14px rgba(0, 0, 0, 0.2);
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;
`

export const useStyles = makeStyles(() => ({
  root: {
    padding: 0,
    marginTop: '10px',
  },
}))
